import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { FaPlus } from "react-icons/fa";
import CreateTransactionModal from "./createTransaction";
import { Toast } from "primereact/toast";
import ReturnComponent from "./realEstateComponent/returnComponent";
import TradeComponent from "./realEstateComponent/tradeComponent";
import PictureComponent from "./realEstateComponent/pictureCompoenent";
import MovementComponent from "./realEstateComponent/movementComponent";
import { formatNumber, truncateText } from "../../../../../utility/helper";
import {
  addMediaService,
  deleteMediaService,
  deleteTransaction,
  getFutureTransaction,
  getRoiRealEstateMediaService,
  getRoiRealEstateService,
  getRoiRealEstateStatsService,
  getTransaction,
  getUserAssets,
} from "../../../../../services/transaction";
import { filterDropdownOptions } from "../../../../../utility/data";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownOptions = [
    { name: "BUY" },
    { name: "EXPENSE" },
    { name: "INCOME" },
    { name: "SELL" },
    { name: "VALUATION" },
  ];
  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [filterType, setFilterType] = useState(filterDropdownOptions[0]);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [viewFutureTransaction, setViewFutureTransaction] = useState([]);
  const [graphROI, setGraphROI] = useState([]);
  const [mediaData, setMediaData] = useState([]);
  const [statsData, setStatsData] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Return");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const id = location?.state?.id || null;
  const userAssets = useSelector((state) => state.userAssets.data);
  const selectedAsset = useSelector((state) => state.userAssets.selectedAsset);
  const sell = viewTransaction?.transactions?.find(
    (item) => item.type === "SELL"
  );
  const isValuation = viewTransaction?.transactions?.find(
    (item) => item.type === "VALUATION"
  );

  useEffect(() => {
    if (selectedAsset) {
      GetTransactionData();
      GetFutureTransactionData();
      GetRoiData();
      GetMediaData();
      GetstatsData();
    }
  }, [selectedAsset, filterType, page]);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 3, selectedAssetId: id }));
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetRoiData = async () => {
    setLoading(true);
    try {
      const response = await getRoiRealEstateService(
        selectedAsset.id,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setGraphROI(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetMediaData = async () => {
    setLoading(true);
    try {
      const response = await getRoiRealEstateMediaService(
        selectedAsset.id,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setMediaData(data ? data : []);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetstatsData = async () => {
    setLoading(true);
    try {
      const response = await getRoiRealEstateStatsService(
        selectedAsset?.id,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setStatsData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTransaction(
        selectedAsset?.id,
        3,
        page * limit,
        limit,
        filterType,
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const GetFutureTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFutureTransaction(
        selectedAsset?.id,
        page,
        limit,
        filterType,
        3,
        accessToken
      );
      if (response.status === 200) {
        setViewFutureTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleTransactionDelete = async (deleteId) => {
    try {
      const response = await deleteTransaction(accessToken, deleteId.id);
      if (response) {
        fetchUserAssets();
        GetTransactionData();
        GetFutureTransactionData();
        GetstatsData();
        GetRoiData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleMediaDelete = async (media_id) => {
    try {
      const response = await deleteMediaService(accessToken, media_id);
      if (response) {
        GetMediaData();
        fetchUserAssets();
        GetTransactionData();
        GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "Image deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleCreateMedia = async (media) => {
    try {
      const response = await addMediaService(
        media,
        selectedAsset?.id,
        "RealEstate",
        accessToken
      );
      if (response) {
        GetMediaData();
        fetchUserAssets();
        GetTransactionData();
        GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "Image upload successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const confirmMediaDelete = (mediaId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this media?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "bg-primary hover:border-white text-gray-300 font-bold py-2 px-4 rounded border border-[rgb(161,147,147)]",
      confirmClass:
        "bg-secondary hover:bg-gray-400 font-bold py-2 px-4 rounded ml-4 text-primary border",
      onConfirm: () => handleMediaDelete(mediaId),
    });
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "bg-primary hover:border-white text-gray-300 font-bold py-2 px-4 rounded border border-[rgb(161,147,147)]",
      confirmClass:
        "bg-secondary hover:bg-gray-400 font-bold py-2 px-4 rounded ml-4 text-primary border",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div className="text-gray-400">
        <CustomDropdown
          options={userAssets}
          name={selectedAsset ? selectedAsset.name : "Select Asset"}
          assetId={selectedAsset ? selectedAsset.id : "Select Asset"}
          onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
          returnFullObject={true}
          truncateText={truncateText}
          size={19}
          className="inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md hover:border hover:border-secondary"
        />
      </div>

      <div className="grid md:grid-cols-12 grid-cols-4">
        <div className="md:col-span-1 col-span-4 text-sm">
          <div className="grid md:grid-cols-2 grid-cols-4 gap-1">
            <div className="ml-1" title={selectedAsset?.name ?? "house1"}>
              {(selectedAsset?.name ?? "").length > 10
                ? (selectedAsset?.name ?? "").substring(0, 10) + "..."
                : selectedAsset?.name ?? ""}
            </div>
          </div>
        </div>

        <div className="md:col-span-10 col-span-4 text-end whitespace-nowrap text-[0.70rem]">
          <div className="grid md:grid-cols-10 grid-cols-4 gap-2 font-bold">
            <div className="mr-4">Valuation</div>
            <div className="flex justify-between">
              <span className="mr-1">CHF</span>
              <span className="mr-1">
                {isValuation
                  ? formatNumber(Number(statsData?.valuation ?? 0).toFixed(2))
                  : formatNumber(
                      Number(statsData?.initial_value ?? 0).toFixed(2)
                    )}
              </span>
            </div>
            <div className="">ROI</div>
            <div className="text-secondary mr-2">
              {formatNumber(Number(statsData?.roi ?? 0).toFixed(2))}%
            </div>
            <div className="mr-4">Realised profit</div>
            <div className="text-secondary flex justify-between ml-2">
              <span className="">CHF</span>
              <span className="">
                {formatNumber(
                  Number(statsData?.realized_profit ?? 0).toFixed(2)
                )}
              </span>
            </div>
            <div className="">INCOME</div>
            <div className="text-secondary flex justify-between ml-2">
              <span className="">CHF</span>
              <span className="">
                {formatNumber(Number(statsData?.income ?? 0).toFixed(2))}
              </span>
            </div>
            <div className="">EXPENSE</div>
            <div className="text-expense flex justify-between ml-2">
              <span className="">CHF</span>
              <span className="">
                {formatNumber(Number(statsData?.expense ?? 0).toFixed(2))}
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-10 grid-cols-4 gap-2 mt-4 font-bold">
            <div className="mr-4">CRR</div>
            <div className="text-secondary flex justify-between">
              <span className="mr-1">CHF</span>
              <span className="mr-1">
                {formatNumber(Number(statsData?.current_crr ?? 0).toFixed(2))}
              </span>
            </div>

            <div className="">{/* IRR */}</div>
            <div className="text-secondary mr-2">
              {/* {formatNumber(Number(statsData?.irr ?? 0).toFixed(2))}% */}
            </div>
            <div className="mr-4">Unrealised profit</div>
            <div className="text-secondary flex justify-between ml-2">
              <span className="">CHF</span>
              <span className="">
                {formatNumber(
                  Number(statsData?.unrealized_profit ?? 0).toFixed(2)
                )}
              </span>
            </div>
            <div className="">Market Value</div>
            <div className="text-secondary flex justify-between ml-2">
              <span className="">CHF</span>
              <span className="">
                {formatNumber(Number(statsData?.market_value ?? 0).toFixed(2))}
              </span>
            </div>
            <div className="">Cap Rate</div>
            <div className="text-secondary">
              {formatNumber(Number(statsData?.cap_rate ?? 0).toFixed(2))}%
            </div>
          </div>
          {/* <div className="grid md:grid-cols-10 grid-cols-4 gap-2 mt-4 font-bold">
            <div className=""></div>
            <div className="text-green-500">
              <span className='mr-3'></span>
            </div>
            <div className=""></div>
            <div className="text-green-500">
              <span className='mr-3'></span>
            </div>
            <div className="">Fond Propre</div>
            <div className="text-secondary">
              {formatNumber(Number(statsData?.fond_propre ?? 0).toFixed(2))}%
            </div>
            <div className="">Debt. Service</div>
            <div className="text-expense flex justify-between ml-2">
              <span className=''>CHF</span>
              <span className=''>{formatNumber(Number(statsData?.debt_service ?? 0).toFixed(2))}</span>
            </div>

            <div className=""></div>
            <div className="text-expense">
              <span className='mr-4'></span>
            </div>
          </div> */}
        </div>
        <div className="text-end">
          <CustomDropdown
            options={dropdownOptions}
            name={""}
            assetId={""}
            icon={<FaPlus />}
            direction={"right"}
            truncateText={truncateText}
            size={19}
            className={`flex items-center justify-center w-12 h-12 rounded-full font-bold 
              ${
                sell
                  ? "bg-gray-400 text-primary cursor-not-allowed"
                  : "bg-secondary text-primary hover:bg-[#148f77]"
              }
            `}
            onOptionSelect={(option) =>
              !sell && handleOptionSelect(option, "Create", {})
            }
            disabled={!!sell}
          />
        </div>
      </div>

      <div className="border-b border-[rgb(35,135,159)] pt-3"></div>
      <div className="grid md:grid-cols-8 grid-cols-4 mt-2">
        {["Return", "Cash Flow", "Movements", "Pictures", "Documents"].map(
          (btn) => (
            <button
              key={btn}
              className={
                selectedButton === btn ? "text-secondary font-bold" : ""
              }
              onClick={() => setSelectedButton(btn)}
            >
              {btn}
            </button>
          )
        )}
      </div>

      <div className="mt-5">
        {selectedButton === "Return" && <ReturnComponent graphROI={graphROI} />}
        {selectedButton === "Cashflow" && <TradeComponent />}
        {selectedButton === "Pictures" && (
          <PictureComponent
            handleMediaDelete={confirmMediaDelete}
            mediaData={mediaData}
            handleCreateMedia={handleCreateMedia}
          />
        )}
        {selectedButton === "Movements" && (
          <MovementComponent
            confirmDelete={confirmTransactionDelete}
            handleOptionSelect={handleOptionSelect}
            viewTransaction={viewTransaction}
            viewFutureTransaction={viewFutureTransaction}
            setLimit={setLimit}
            limit={limit}
            setPage={setPage}
            page={page}
          />
        )}
      </div>
      <CreateTransactionModal
        visible={modalVisible}
        singleTransactionData={singleTransactionData}
        actionTypes={actionTypes}
        fetchTransactionData={GetTransactionData}
        fetchFutureTransactionData={GetFutureTransactionData}
        GetstatsData={GetstatsData}
        GetRoiData={GetRoiData}
        statsData={statsData}
        viewTransaction={viewTransaction}
        onHide={() => {
          setModalVisible(false);
        }}
        SelectType={type}
        toast={toast}
        loading={loading}
        setLoading={setLoading}
        assetName={selectedAsset}
      />
    </>
  );
};

export default ViewTransaction;
